import { render, staticRenderFns } from "./CommonParagraphsBlock.vue?vue&type=template&id=9fe76b66&scoped=true&"
import script from "./CommonParagraphsBlock.vue?vue&type=script&lang=ts&"
export * from "./CommonParagraphsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CommonParagraphsBlock.vue?vue&type=style&index=0&id=9fe76b66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe76b66",
  null
  
)

export default component.exports